import { render, staticRenderFns } from "./RuleGeneral.vue?vue&type=template&id=01e41d9a&"
import script from "./RuleGeneral.vue?vue&type=script&lang=js&"
export * from "./RuleGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports